import styled from 'styled-components';
import { Flex, Link } from '@amzn/storm-ui';
import { PAGE_LAYOUT_TYPE } from 'src/app/slice';

export const FooterWrapper = styled.div<{ pageLayoutType: PAGE_LAYOUT_TYPE }>`
  box-sizing: border-box;
  padding: ${({ theme }) => theme.spacing.base.default};

  ${(props) =>
    [PAGE_LAYOUT_TYPE.STANDARD, PAGE_LAYOUT_TYPE.INTERNAL_STANDARD].includes(
      props.pageLayoutType,
    )
      ? `
        margin-inline-start: 64px;
      `
      : ''};
`;

export const FooterLink = styled(Link)`
  &&& {
    color: ${({ theme }) => theme.text.color.default};
  }

  text-decoration: none;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`;

export const MobileLinksWrapper = styled(Flex)`
  margin-bottom: ${({ theme }) => theme.spacing.small.mobile};
  padding-inline: ${({ theme }) => theme.spacing.xsmall.mobile};
  flex-flow: wrap;
`;

export const FooterLinkMobile = styled(Link)`
  margin: 0 10px;

  &&& {
    color: ${({ theme }) => theme.link.color.default};
  }

  // The last item should be a block element

  &:last-child {
    display: block;
  }
`;

export const DesktopToggleWrap = styled.div`
  font-size: 40px;
  width: 100%;
  text-align: center;
  margin-bottom: 16px;
`;
